export default __webpack_public_path__ + "static/media/casual-girl-using-microwave-heat-cup@2x.7a6991b9.png";